<ul class="navbar-nav ds-dashboard-nav__menu">
  <li class="nav-item dropdown">
    <a class="nav-link dropdown-toggle" [ngClass]="{ 'active': activeClass || isOpen, 'isFunctionOpen': !isOpen }" href="#" role="button" (click)="handleDropdownClick($event)" aria-expanded="false">
      {{ dropdownLabel }}
      @if (dropdownItems?.length > 0) {<img class="arrow-icon" [src]="ICONS.CHEVRON_DOWN" alt="">}
    </a>
    @if (dropdownItems?.length > 0) {<ul class="dropdown-menu" [ngClass]="{ 'show': isOpen }">
      @for (item of dropdownItems; track item; let idx = $index) {<li>
        <a class="dropdown-item" href="#" (click)="onItemClick(item, $event)">
          {{ item.label }}
        </a>
      </li>
      }
    </ul>
    }
  </li>
</ul>
